<template>
  <div class="blog-tags">
    <span v-if="category" class="s-badge s-badge-dark s-badge-blog-category category">{{ category }}</span>
    <a v-for="tag in tags" :key="tag" :href="`/pulse/tags/${tag.slug}`" class="s-badge s-badge-grey tag">{{ tag.name }}</a>
  </div>
</template>

<script setup>
defineProps({
  tags: Array,
  category: String,
});
</script>

<style scoped>



</style>
